export function initLoadingText() {
  document.querySelectorAll("form").forEach((form) => {
    form.addEventListener("submit", () => {
      const submitBtn = form.querySelector('button[type="submit"][data-loading-text]')
      if (!submitBtn) return

      submitBtn.textContent = submitBtn.dataset.loadingText
      setTimeout(() => {
        submitBtn.disabled = true
      }, 0)
    })
  })
}
